import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontAngkor, theme } from "shared/lib/styles";

import LinkIcon from "./icon-link.svg";

export const Container = styled.div`
  inline-size: fit-content;
  margin-block: 0;
  margin-inline: auto;
`;

export const StyledBaseLink = styled(BaseLink)`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    align-items: flex-start;
  }
`;

type HeadlineTextProps = {
  $color: string;
};

export const HeadlineText = styled.span<HeadlineTextProps>`
  display: block;

  color: ${props => props.$color};
  font-weight: 400;
  font-size: 36px;
  font-family: ${fontAngkor};
  line-height: 40px;
  letter-spacing: -0.72px;
  text-align: center;
  text-transform: uppercase;

  ${theme.breakpoints.up("tablet")} {
    margin-inline-end: 8px;

    font-size: 44px;
    line-height: 56px;
    letter-spacing: -1.32px;
  }

  ${theme.breakpoints.up("desktop")} {
    font-size: 48px;
    letter-spacing: -1.44px;
  }
`;

export const StyledLinkIcon = styled(LinkIcon)`
  inline-size: 38px;
  block-size: 38px;
  ${theme.breakpoints.up("tablet")} {
    inline-size: 48px;
    block-size: 48px;
  }
`;
